
import { createAction } from 'redux-actions';
import type { ErrorParsedResponse } from 'webApp';

import {
  OWNER_LOGIN,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAILURE,
} from '../../actionTypes';


/**
 * Login owner
 */
export type LoginOwnerParams = {
  username: string,
  password: string,
};

export type LoginOwnerPayload = LoginOwnerParams;

export type LoginOwnerAction = {
  type: typeof OWNER_LOGIN,
  payload: LoginOwnerPayload,
};

export const loginOwner: (LoginOwnerParams) => LoginOwnerAction = createAction(OWNER_LOGIN, ({
  username,
  password,
}) => ({
  username,
  password,
}));


/**
 * Login owner success
 */
export type LoginOwnerSuccessParams = {
  ownerToken: string,
  ownerID: string | number,
};

export type LoginOwnerSuccessPayload = LoginOwnerSuccessParams;

export type LoginOwnerSuccessAction = {
  type: typeof OWNER_LOGIN_SUCCESS,
  payload: LoginOwnerSuccessPayload,
};

export const loginOwnerSuccess: (
  LoginOwnerSuccessParams,
) => LoginOwnerSuccessAction = createAction(
  OWNER_LOGIN_SUCCESS,
  ({
    ownerToken,
    ownerID,
  }) => ({
    ownerToken,
    ownerID,
  }),
);


/**
 * Login owner failure
 */
export type LoginOwnerFailureAction = {
  type: typeof OWNER_LOGIN_FAILURE,
  payload: ErrorParsedResponse,
};

export const loginOwnerFailure: (
  ErrorParsedResponse,
) => LoginOwnerFailureAction = createAction(
  OWNER_LOGIN_FAILURE,
);
